<template>
  <div v-if="quanxian">
    <div class="zongjixiao">总绩效: <span style="color: red">{{zongjixiao}}</span></div>
    <div class="staff">
      <div class="staffTitle">
        <div class="jiangbeileft">
          <div class="jiangbeiimg">
            <img src="https://static.sprucesmart.com/lzrh/jiangbei.png" alt />
          </div>业绩奖
        </div>
        <el-select v-model="value" placeholder="请选择" @change="changeFun">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            
          ></el-option>
        </el-select>
        <div class="nowMonth">当前月:{{currentMonth}}</div>
      </div>
      <div class="jixiaogongziitem" v-for="(item,index) in jixiaogongziList" :key="index">
        <span>{{item.name}}:<span style="color: red;">{{item.value}}</span></span>
      </div>
      <div class="totaljixiao">应发业绩奖：{{jixiaogongzi}}</div>
    </div>
    <div class="zhuanxiangcontent">
      <div class="staffTitle">
        <div class="jiangbeileft">
          <div class="jiangbeiimg">
            <img src="https://static.sprucesmart.com/lzrh/jiangbei2.png" alt />
          </div>专项奖
        </div>
      </div>
      <div class="zhuanxiangitem" v-for="(item,index) in zhuanxiangList" :key="index">
        <span>{{item.name}}:<span style="color: red;">{{item.value}}</span></span>
      </div>
      <div class="totalzhuangxiang">应发专项奖：{{zhuanxianggongzi}}</div>
    </div>
  </div>
  <div v-else>暂无数据</div>
</template>

<script>
import { getcheck } from "@/api/checkapi";
import { query } from '@/api/query';
export default {
  data() {
    return {
      zongjixiao: '', // 总绩效
      jixiaogongziList: [],
      jixiaogongzi: 0,
      zhuanxiangList: [],
      zhuanxianggongzi: 0,
      quanxian: true,
      currentMonth: "",
      options: [
        {
          value: "",
          label: "",
        }
      ],
      value: "",
    };
  },
  created() {
    this.getcheckdata();
  },
  methods: {
    changeFun(vID) {
      console.log('this.value',this.value)
      const querydata = query(this.value)
      querydata.then((res)=>{
        if (res.data.errno == 0) {
        // console.log('res',res)
          this.quanxian = true;
          this.zongjixiao = res.data.results.zonggongzi
          this.jixiaogongzi = res.data.results.jixiaogongzi;
          this.jixiaogongziList = res.data.results.jixiaogongzi_list;
          this.zhuanxianggongzi = res.data.results.zhuanxianggongzi;
          this.zhuanxiangList = res.data.results.zhuanxianggongzi_list;
          // 当前月
          this.currentMonth = res.data.results.current_month;
          this.options = res.data.results.month_list;
        }else {
          this.quanxian = false;
        }
      })
    },
    getcheckdata() {
      const staffcheckdata = getcheck();
      staffcheckdata.then((res) => {
        if (res.data.errno == 0) {
          console.log(res);
          this.quanxian = true;
          this.zongjixiao = res.data.results.zonggongzi
          this.jixiaogongzi = res.data.results.jixiaogongzi;
          this.jixiaogongziList = res.data.results.jixiaogongzi_list;
          this.zhuanxianggongzi = res.data.results.zhuanxianggongzi;
          this.zhuanxiangList = res.data.results.zhuanxianggongzi_list;
          // 当前月
          this.currentMonth = res.data.results.current_month;
          this.options = res.data.results.month_list;
        } else {
          this.quanxian = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.zongjixiao {
  width: 100%;
  height: 60px;
  background-color: #fff;
  margin-bottom: 30px;
  border-radius: 20px;
  box-shadow: 0px 8px 10px 0px rgba(219, 225, 255, 0.5);
  font-size: 28px;
  padding: 10px 42px;
  box-sizing: border-box;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(28, 42, 58, 1);
}
.staff,
.zhuanxiangcontent {
  width: 100%;
  height: 520px;
  background: #ffffff;
  border-radius: 20px;
  border-bottom: 1px solid #cccccc;
  box-shadow: 0px 8px 10px 0px rgba(219, 225, 255, 0.5);
  // padding: 20px 150px 0 150px;
  // box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-flow: wrap;
  .staffTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 86px;
    border-bottom: 2px solid #dddfef;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(28, 42, 58, 1);
    line-height: 86px;
    padding-left: 42px;
    box-sizing: border-box;
    .jiangbeiimg {
      display: inline-block;
      width: 39px;
      height: 47px;
      margin-right: 10px;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .nowMonth {
      margin-right: 190px;
    }
  }

  .jixiaogongziitem,
  .zhuanxiangitem {
    width: 33%;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(24, 144, 255, 1);
    padding-left: 109px;
    box-sizing: border-box;
    span {
      display: inline-block;
      background: rgba(240, 242, 250, 1);
      border-radius: 24px;
      padding: 9px 19px;
      box-sizing: border-box;
    }
    // span:first-child {
    //   display: inline-block;
    //   margin-right: 50px;

    // }
    // span:last-child {
    //   display: inline-block;
    //   height: 30px;
    //   font-size: 26px;
    //   color: #409EFF;
    // }
  }
  .totaljixiao,
  .totalzhuangxiang {
    width: 100%;
    height: 30px;
    text-align: right;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(132, 143, 155, 1);
    padding-right: 192px;
    box-sizing: border-box;
  }
}
.zhuanxiangcontent {
  height: 410px;
  margin-top: 30px;
}
</style>
